export default {
  "arrow-down-grey-no-shaft": "assets/shared/global-images/icon-set/arrow-down-grey-no-shaft.svg",
  "arrow-down-blue": "assets/shared/global-images/icon-set/arrow-down-blue.svg",
  "arrow-left-grey": "assets/shared/global-images/icon-set/arrow-left-grey.svg",
  "arrow-up-grey-no-shaft": "assets/shared/global-images/icon-set/arrow-up-grey-no-shaft.svg",
  "arrow-right-blue": "assets/shared/global-images/icon-set/arrow-right-blue.svg",
  "arrow-right-grey": "assets/shared/global-images/icon-set/arrow-right-grey.svg",
  "arrow-right-shaft-grey": "assets/shared/global-images/icon-set/arrow-right-shaft-grey.svg",
  "arrow-right-white": "assets/shared/global-images/icon-set/arrow-right-white.svg",
  "arrow-up-black": "assets/shared/global-images/icon-set/arrow-up-black.svg",
  "arrow-down-black": "assets/shared/global-images/icon-set/arrow-down-black.svg",
  "attachment": "assets/shared/global-images/icon-set/attachment.svg",
  "calendar": "assets/shared/global-images/icon-set/calendar.svg",
  "checkmark-blue-rectangle": "assets/shared/global-images/icon-set/checkmark-blue-rectangle.svg",
  "checkmark-green-rectangle": "assets/shared/global-images/icon-set/checkmark-green-rectangle.svg",
  "checkmark-green-circle": "assets/shared/global-images/icon-set/checkmark-green-circle.svg",
  "checkmark-darker-green-circle": "assets/shared/global-images/icon-set/checkmark-darker-green-circle.svg",
  "checkmark-grey-circle": "assets/shared/global-images/icon-set/checkmark-grey-circle.svg",
  "checkmark-blue-circle": "assets/shared/global-images/icon-set/checkmark-blue-circle.svg",
  "copy-white": "assets/shared/global-images/icon-set/copy-white.svg",
  "copy-blue": "assets/shared/global-images/icon-set/copy-blue.svg",
  "cross-black": "assets/shared/global-images/icon-set/cross-black.svg",
  "cross-white-circle-black": "assets/shared/global-images/icon-set/cross-white-circle-black.svg",
  "edit-grey": "assets/shared/global-images/icon-set/edit-grey.svg",
  "eyes-off": "assets/shared/global-images/icon-set/eyes-off.svg",
  "eyes-on": "assets/shared/global-images/icon-set/eyes-on.svg",
  "info-grey-outline": "assets/shared/global-images/icon-set/info-grey-outline.svg",
  "logout-grey": "assets/shared/global-images/icon-set/logout-grey.svg",
  "logout-red": "assets/shared/global-images/icon-set/logout-red.svg",
  "minus-grey-rectangle-outline": "assets/shared/global-images/icon-set/minus-grey-rectangle-outline.svg",
  "more-blue": "assets/shared/global-images/icon-set/more-blue.svg",
  "plus-black-circle-white": "assets/shared/global-images/icon-set/plus-black-circle-white.svg",
  "plus-black-square-grey": "assets/shared/global-images/icon-set/plus-black-square-grey.svg",
  "questionmark-grey-circle": "assets/shared/global-images/icon-set/questionmark-grey-circle.svg",
  "questionmark": "assets/shared/global-images/icon-set/questionmark.svg",
  "thumbs-up-grey-outline": "assets/shared/global-images/icon-set/thumbs-up-grey-outline.svg",
  "trash-red": "assets/shared/global-images/icon-set/trash-red.svg",
  "trash-black": "assets/shared/global-images/icon-set/trash-black.svg",
  "stop-sign": "assets/shared/global-images/icon-set/stop-sign.svg",
  "swap-status": "assets/shared/global-images/icon-set/swap-status.svg",
  "inbox-down": "assets/shared/global-images/icon-set/inbox-down.svg",
  "envelope-send": "assets/shared/global-images/icon-set/envelope-send.svg",
  "plane-takeoff": "assets/shared/global-images/icon-set/plane-takeoff.svg",
  "plane-landing": "assets/shared/global-images/icon-set/plane-landing.svg",
  "upload-cloud-grey": "assets/shared/global-images/icon-set/upload-cloud-grey.svg",
  "clock": "assets/shared/global-images/icon-set/clock.svg",
  "pencil": "assets/shared/global-images/icon-set/pencil.svg",
  "house": "assets/shared/global-images/icon-set/house.svg",
  "coins": "assets/shared/global-images/icon-set/coins.svg",
  "refund": "assets/shared/global-images/icon-set/refund.svg",
  "simple-calendar": "assets/shared/global-images/icon-set/simple-calendar.svg",
  "plus-grey": "assets/shared/global-images/icon-set/plus-grey.svg",
  "document": "assets/shared/global-images/icon-set/document.svg",
  "document-form": "assets/shared/global-images/icon-set/document-form.svg",
  "frying-pan": "assets/shared/global-images/icon-set/frying-pan.svg",
  "falling-domino": "assets/shared/global-images/icon-set/falling-domino.svg",
  "paper-plane": "assets/shared/global-images/icon-set/paper-plane.svg",
  "headset": "assets/shared/global-images/icon-set/headset.svg",
  "plus-grey-thick": "assets/shared/global-images/icon-set/plus-grey-thick.svg",
  "plus-blue": "assets/shared/global-images/icon-set/plus-blue.svg",
  "amex": "assets/shared/global-images/icon-set/amex.svg",
  "barion": "assets/shared/global-images/icon-set/barion.svg",
  "maestro": "assets/shared/global-images/icon-set/maestro.svg",
  "mastercard": "assets/shared/global-images/icon-set/mastercard.svg",
  "external-link-white": "assets/shared/global-images/icon-set/external-link-white.svg",
  "external-link-blue": "assets/shared/global-images/icon-set/external-link-blue.svg",
  "visa": "assets/shared/global-images/icon-set/visa.svg",
  "visa-electron": "assets/shared/global-images/icon-set/visa-electron.svg",
  "qvik-blue": "assets/shared/global-images/icon-set/qvik-blue.svg",
  "szamlazz-hu": "assets/shared/global-images/partner-logos/szamlazz-hu.svg",
  "szamlazz-hu-person": "assets/shared/global-images/partner-logos/szamlazz-hu-person.svg",
  "radio-unchecked-grey": "assets/shared/global-images/icon-set/radio-unchecked-grey.svg",
  "radio-checked-blue": "assets/shared/global-images/icon-set/radio-checked-blue.svg",
  "hard-icon": "assets/shared/global-images/icon-set/hard-icon.svg",
  "add-claim": "assets/shared/global-images/icon-set/add-claim.svg",
  "plus-black": "assets/shared/global-images/icon-set/plus-black.svg",
  "demand-letter-icon": "assets/shared/global-images/icon-set/demand-letter-icon.svg",
  "gdpr": "assets/shared/global-images/icon-set/gdpr.svg",
  "ssl": "assets/shared/global-images/icon-set/ssl.svg",
  "find-black": "assets/shared/global-images/icon-set/find-black.svg",
  "toggle-on": "assets/shared/global-images/icon-set/toggle-on.svg",
  "toggle-off": "assets/shared/global-images/icon-set/toggle-off.svg",
  "hu-flag-circle": "assets/shared/global-images/icon-set/hu-flag-circle.svg",
  "en-flag-circle": "assets/shared/global-images/icon-set/en-flag-circle.svg",
  "attorney-icon": "assets/shared/global-images/icon-set/attorney-icon.svg",
  "soft-icon": "assets/shared/global-images/icon-set/soft-icon.svg",
  "big-checkmark-green-circle": "assets/shared/global-images/icon-set/big-checkmark-green-circle.svg",
  "payee-logo": "assets/shared/global-images/payee-logos/v1/black-payee-with-badge.svg",
  "checkbox-empty": "assets/shared/global-images/icon-set/checkbox-empty.svg",
  "arrow-down-darker-blue": "assets/shared/global-images/icon-set/arrow-down-darker-blue.svg",
  "checkbox-filled": "assets/shared/global-images/icon-set/checkbox-filled.svg",
  "toggle-on-disabled": "assets/shared/global-images/icon-set/toggle-on-disabled.svg",
  "szamlazzhu-icon": "assets/shared/global-images/icon-set/szamlazzhu-icon.svg",
  "success-icon": "assets/shared/global-images/icon-set/success-icon.svg",
  "case-success-tick": "assets/shared/global-images/icon-set/case-success-tick.svg",
  "upload-cloud": "assets/shared/global-images/icon-set/upload-cloud.svg",
  "upload-paper": "assets/shared/global-images/icon-set/upload-paper.svg",
  "uploaded-document": "assets/shared/global-images/icon-set/uploaded-document.svg",
  "disabled-calendar": "assets/shared/global-images/icon-set/disabled-calendar.svg",
  "lock-blue": "assets/shared/global-images/icons/lock-blue.svg",
  "lock-grey": "assets/shared/global-images/icons/lock-grey.svg",
  "lock-grey-thin": "assets/shared/global-images/icons/lock-grey-thin.svg",

  // form icons
  "form-org": "assets/shared/global-images/icon-set/org.svg",
  "form-ind": "assets/shared/global-images/icon-set/person.svg",
  "collapse": "assets/shared/global-images/icon-set/collapse.svg",
  "expand": "assets/shared/global-images/icon-set/expand.svg",

  // form logos
  "bupa-logo": "assets/shared/global-images/partner-logos/form-logos/bupa.svg",
  "cashbook-logo": "assets/shared/global-images/partner-logos/form-logos/cashbook.svg",
  "cashman-logo": "assets/shared/global-images/partner-logos/form-logos/cashman.svg",
  "clouderp-logo": "assets/shared/global-images/partner-logos/form-logos/clouderp.svg",
  "ehaz-logo": "assets/shared/global-images/partner-logos/form-logos/ehaz.svg",
  "innvoice-logo": "assets/shared/global-images/partner-logos/form-logos/innvoice.svg",
  "instacash-logo": "assets/shared/global-images/partner-logos/form-logos/instacash.svg",
  "kulcssoft-logo": "assets/shared/global-images/partner-logos/form-logos/kulcssoft.svg",
  "otpebiz-logo": "assets/shared/global-images/partner-logos/form-logos/otpebiz.svg",
  "quick-logo": "assets/shared/global-images/partner-logos/form-logos/quick.svg",
  "shoprenter-logo": "assets/shared/global-images/partner-logos/form-logos/shoprenter.svg",
  "shoptet-logo": "assets/shared/global-images/partner-logos/form-logos/shoptet.svg",
  "symbion-logo": "assets/shared/global-images/partner-logos/form-logos/symbion.svg",
  "szamlazzhu-logo": "assets/shared/global-images/partner-logos/form-logos/szamlazzhu.svg",
  "tharanis-logo": "assets/shared/global-images/partner-logos/form-logos/tharanis.svg",
  "whmcloud-logo": "assets/shared/global-images/partner-logos/form-logos/whmcloud.svg",

  // mini logos
  "ehaz-mini": "assets/shared/global-images/partner-logos/mini-logos/ehaz.svg",
  "other-mini": "assets/shared/global-images/partner-logos/mini-logos/other.svg",
  "payee-mini": "assets/shared/global-images/payee-logos/v1/payee-webclip-black.svg",
  "quick-mini": "assets/shared/global-images/partner-logos/mini-logos/quick.svg",
  "szamlazzhu-mini": "assets/shared/global-images/partner-logos/mini-logos/szamlazzhu.svg",
  "whm-mini": "assets/shared/global-images/partner-logos/mini-logos/whm.svg",

  // form logos
  "szamlazzhu": "assets/shared/global-images/partner-logos/form-logos/szamlazzhu.svg",
  "ehaz": "assets/shared/global-images/partner-logos/form-logos/ehaz.svg",
  "quick": "assets/shared/global-images/partner-logos/form-logos/quick.svg",
  "cashbook": "assets/shared/global-images/partner-logos/form-logos/cashbook.svg",
  "cashman": "assets/shared/global-images/partner-logos/form-logos/cashman.svg",
  "kulcssoft": "assets/shared/global-images/partner-logos/form-logos/kulcssoft.svg",
};
